import React from 'react'
import './index.css';
import { NavLink } from "react-router-dom";

const Navbar = () => {
    return (
        <div>
            <nav className='navbar bg-dark'>
                <div className='container'>
                    <h1 className='logo lg-heading text-light'>Gravity Gym</h1>
                    <ul className='nav-items'>
                        <li className='nav-item'><NavLink activeClassName="menu_active" exact to="./">HOME</NavLink></li>
                        <li className='nav-item'><NavLink activeClassName="menu_active" exact to="./price">PRICING</NavLink></li>
                        <li className='nav-item'><NavLink activeClassName="menu_active" exact to="./about">ABOUT</NavLink></li>
                        <li className='nav-item'><NavLink activeClassName="menu_active" exact to="./contact">CONTACT</NavLink></li>
                    </ul>
                </div>
            </nav>
        </div>
    )
}

export default Navbar
